// アプリのURL
export const appUrl = process.env.NEXT_PUBLIC_APP_URL;

// APIのURL
export const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

// 開発用のモックサーバURL
export const jsonServerUrl = "http://localhost:3004";
